const TITLE_AR_EN = /^(.+?)\s*\(\s*(.+?)\s*\)\s*$/;

export function HrmDualToneTitle({ title }: { title: string }) {
    const headingClass = 'sm:text-[28px] text-[20px] md:text-[23px] lg:text-[23px] font-bold leading-tight';
    const match = title.match(TITLE_AR_EN);
    if (!match) {
        return <h3 className={`${headingClass} text-primary-text`}>{title}</h3>;
    }
    const [, ar, en] = match;
    return (
        <h3 className={headingClass}>
            <span className="text-[#5691C8]">{ar.trim()}</span> <span className="text-primary-text">({en.trim()})</span>
        </h3>
    );
}
